import * as z from 'zod';

const pipeline = ['LC', 'PR', 'AQ', 'ZZ'] as const;

const pipelineOptionsValues = z.enum(pipeline);

export const pipelineQuerySchema = pipelineOptionsValues.nullable();
type PipelineQuerySchema = z.infer<typeof pipelineQuerySchema>;
export type PipelineMutationSchema = z.infer<typeof pipelineQuerySchema>;

export const pipelineOptions: PipelineFormSchema[] = pipeline.map((value) => ({ name: value, value }));

export const pipelineFormSchema = z.object({
  name: z.string(),
  value: pipelineOptionsValues,
});

type PipelineFormSchema = z.infer<typeof pipelineFormSchema>;

export const defaultPipeline: PipelineFormSchema = pipelineOptions[0];

export function pipelineToStr(p?: PipelineFormSchema | null, isAddendum?: boolean) {
  if (p?.value === null || typeof p?.value === 'undefined') {
    return isAddendum ? null : pipeline[0];
  }
  return p.value;
}

export function strToPipeline(p: PipelineQuerySchema, isAddendum?: boolean): PipelineFormSchema | null {
  if (!p) {
    return isAddendum ? null : pipelineOptions[0];
  }
  return pipelineOptions.find((o) => o.value === p) || pipelineOptions[0];
}
